import { Link } from 'react-router-dom';
import RadarChart from './RadarChart';

interface PoliticianCardProps {
  id: string;
  name: string;
  photoUrl?: string;
  partyName: string;
  partyAbbrev: string;
  partyColor?: string;
  positionTitle: string;
  stateName?: string;
  rating: number;
  stats: {
    initiatives: number;
    attendance: number;
    approvals: number;
    speeches: number;
  };
}

export default function PoliticianCard({
  id,
  name,
  photoUrl,
  partyName,
  partyAbbrev,
  partyColor = '#6B7280',
  positionTitle,
  stateName,
  rating,
  stats,
}: PoliticianCardProps) {
  const ratingColor = rating >= 80 ? 'text-green-600' : rating >= 60 ? 'text-yellow-600' : 'text-red-600';
  const ratingBg = rating >= 80 ? 'bg-green-100' : rating >= 60 ? 'bg-yellow-100' : 'bg-red-100';

  const radarData = [
    { subject: 'Actividad', A: Math.min(stats.initiatives * 5, 100), fullMark: 100 },
    { subject: 'Asistencia', A: stats.attendance, fullMark: 100 },
    { subject: 'Aprobación', A: stats.approvals, fullMark: 100 },
    { subject: 'Participación', A: stats.speeches * 10, fullMark: 100 },
  ];

  return (
    <Link to={`/politico/${id}`} className="card-hover group">
      <div className="flex items-start space-x-4">
        {/* Photo */}
        <div className="flex-shrink-0">
          <div className="w-20 h-20 rounded-full bg-gray-200 overflow-hidden">
            {photoUrl ? (
              <img src={photoUrl} alt={name} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
            )}
          </div>
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="font-semibold text-gray-900 group-hover:text-primary-600 transition-colors truncate">
                {name}
              </h3>
              <p className="text-sm text-gray-500">{positionTitle}</p>
              {stateName && <p className="text-sm text-gray-500">{stateName}</p>}
            </div>

            {/* Rating */}
            <div className={`flex-shrink-0 px-3 py-1 rounded-full ${ratingBg}`}>
              <span className={`font-bold ${ratingColor}`}>{rating}</span>
              <span className="text-gray-500 text-sm">/100</span>
            </div>
          </div>

          {/* Party Badge */}
          <div className="mt-2 flex items-center space-x-2">
            <span
              className="inline-block w-3 h-3 rounded-full"
              style={{ backgroundColor: partyColor }}
            />
            <span className="text-sm text-gray-600">{partyName}</span>
          </div>
        </div>
      </div>

      {/* Mini Radar Chart */}
{/* Temporarily disabled radar chart
        <div className="mt-4 h-32">
          <RadarChart data={radarData} size={{ width: 120, height: 120 }} />
        </div>
        */}

      {/* Quick Stats */}
      <div className="mt-4 grid grid-cols-3 gap-4 text-center">
        <div>
          <p className="text-lg font-semibold text-gray-900">{stats.initiatives}</p>
          <p className="text-xs text-gray-500">Iniciativas</p>
        </div>
        <div>
          <p className="text-lg font-semibold text-gray-900">{stats.attendance}%</p>
          <p className="text-xs text-gray-500">Asistencia</p>
        </div>
        <div>
          <p className="text-lg font-semibold text-gray-900">{stats.approvals}%</p>
          <p className="text-xs text-gray-500">Aprobación</p>
        </div>
      </div>
    </Link>
  );
}
